import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_employee_branch_designation_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  branch_designation_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  designation_code: fromDatatype.VarcharDatatypeInterface;
  designation_name: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.NumericDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_employee_branch_designation_link_RowClass implements bl_fi_mst_employee_branch_designation_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  branch_designation_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_approval_setting_guid: fromDatatype.GuidDataFieldInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  designation_code: fromDatatype.VarcharDatatypeInterface;
  designation_name: fromDatatype.VarcharDatatypeInterface;
  approval_level: fromDatatype.NumericDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
